export { default } from "./Password";
